// Math Concepts 관련 유틸리티 함수들
// MathConceptsContext를 대체하여 각 컴포넌트에서 직접 사용

import { fetchWithTokenRefresh } from './apiUtils';

// 캐시 저장소
let mathConceptsCache = null;
let cacheTimestamp = null;
const CACHE_DURATION = 5 * 60 * 1000; // 5분

// Math Concepts 가져오기
export const fetchMathConcepts = async (forceRefresh = false) => {
  try {
    // 캐시 확인
    const now = Date.now();
    if (!forceRefresh && mathConceptsCache && cacheTimestamp && (now - cacheTimestamp < CACHE_DURATION)) {
      console.log('Returning cached math concepts');
      return mathConceptsCache;
    }

    console.log('Fetching math concepts from /api/mathcepts/temp');
    
    const response = await fetchWithTokenRefresh('/api/mathcepts/temp');

    if (response.status === 'success' && response.data) {
      const concepts = response.data.map(item => ({
        id: item.concept_id,
        text: item.concept_name || item.text || item.name || '', // 여러 가능한 필드 확인
        order: item.order,
        category: item.category || '',
        level: item.level || 1,
        conceptId: item.concept_id,
        concept_name: item.concept_name, // 원본 필드도 보존
        concept_type: item.concept_type || null, // concept_type 필드 추가
        math_type: item.math_type || null, // math_type 필드 추가
        tags: item.tags || [] // tags 필드 추가
      }));
      
      // 캐시 업데이트
      mathConceptsCache = concepts;
      cacheTimestamp = now;
      
      return concepts;
    } else {
      console.error('Math concepts API returned error:', response);
      return [];
    }
  } catch (error) {
    // 403 에러인 경우 빈 배열 반환 (teacher 권한 문제)
    if (error.message && error.message.includes('403')) {
      console.warn('Math concepts API returned 403 - using empty array for teacher users');
      return [];
    }
    console.error('Error fetching math concepts:', error);
    return [];
  }
};

// Helper function to get concept text by ID
export const getConceptText = (mathConcepts, conceptId) => {
  const concept = mathConcepts.find(c => c.id === parseInt(conceptId));
  return concept ? concept.text : `개념 ${conceptId}`;
};

// Helper function to get concept order by ID
export const getConceptOrder = (mathConcepts, conceptId) => {
  const concept = mathConcepts.find(c => c.id === parseInt(conceptId));
  return concept ? concept.order : conceptId;
};

// Helper function to get full concept data by ID
export const getConceptById = (mathConcepts, conceptId) => {
  return mathConcepts.find(c => c.id === parseInt(conceptId));
};

// 캐시 초기화 함수 (필요한 경우 사용)
export const clearMathConceptsCache = () => {
  mathConceptsCache = null;
  cacheTimestamp = null;
};
